import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

const title = 'Hello React!';

ReactDOM.render(<App title={title} />, document.getElementById('app'));
